(function() {
    function okeWidgetControlInit() {
      function moveSortSelect() {
        var destination = document.querySelector('.js-okeReviews-reviewsAggregateContainer');
        var sortSelect = document.querySelector('.okeReviews-reviews-controls-select');
        if (destination && sortSelect) {
          destination.appendChild(sortSelect);
        }
      }
      moveSortSelect();
    }
  
    window.okeReviewsWidgetOnInit = okeWidgetControlInit;
  })();
  